export default __webpack_public_path__ + "static/media/car-crash.062e3d0a.svg";